import React from 'react'
import "../../styles/programPage.scss";



/**
* @author
* @function Program
**/

const ProgramMain = (props) => {
  return(
  <>
<div className="item-first-wrapper">
<div className="Program-Top">
<div className="program-hr"></div>&nbsp;&nbsp;
          <h2 className="programh2">हाम्रो वार्षिक <span className="span"> कार्यक्रमहरु</span></h2>
          <div className="program-hr"></div>
        </div>
        <div className="item-firstprogram">
        <div className="triangle-right">
        </div>
       <div className="content">
       वार्षिक नगर विकास योजना २०७५/०७६
       </div>

       </div>
       <hr></hr>


       <div className="item-firstprogram">
        <div className="triangle-right">
        </div>
       <div className="content">
       आ.व. २०७३।७४ का लागि भौतिक पूर्वाधार अन्तर्गतका लक्षित योजनाहरु
       </div>
       </div>
       <hr></hr>
       <div className="item-firstprogram">
        <div className="triangle-right">
        </div>
       <div className="content">
       आ. व. २०७५/७६ को बजेट पुस्तिका
       </div>
       </div>
       <hr></hr>

       <div className="item-firstprogram">
        <div className="triangle-right">
        </div>
       <div className="content">
       वार्षिक नगर विकास योजना २०७५/०७६
       </div>
       </div>
       <hr></hr>


       <div className="item-firstprogram">
        <div className="triangle-right">
        </div>
       <div className="content">
       आ.व. २०७३।७४ का लागि भौतिक पूर्वाधार अन्तर्गतका लक्षित योजनाहरु

       </div>
       </div>
       <hr></hr>

       <div className="item-firstprogram">
        <div className="triangle-right">
        </div>
       <div className="content">
       आ.व. २०७२।७३ का लागि लक्षित कार्यक्रमहरु

       </div>
       </div>
       <hr></hr>
       </div>
</>
   )

 }

export default ProgramMain